(function() {
'use strict';

angular.module('TR')
    .service('currentDestination', currentDestination);

function currentDestination($routeParams, tripService, searchUnitService, destinationService, $q) {
    const service = {
        getCurrentDestination
    };

    function getCurrentDestination(options) {
        return destinationFn(options).then(destination => {
            if (destination == null) {
                return null;
            }
            return destinationService.enhanceDestinationFromPreferences(destination).then(() => destination);
        });
    }

    const defaults = {
        useTrip: true,
        useLandingPage: true,
        useSearchUnitService: true
    };

    function destinationFn(options) {
        options = angular.extend({}, defaults, options);

        if (options.useTrip && $routeParams.tripId) {
            return tripService.getTripDestination($routeParams.tripId);
        }
        if (options.useLandingPage && $routeParams.landingPageV4) {
            return destinationService.fromUrl(`/${$routeParams.urlText}/${$routeParams.landingPageV4}`, $routeParams.tm)
                .then(destinationService.enhanceLegacyDestination)
                .then(destinationService.getDetails);
        }
        if (options.useLandingPage && ($routeParams.landingPageV2 || $routeParams.landingPageV3)) {
            let tmParam = $routeParams.tm || '2';
            let route = '';
            if ($routeParams.landingPageV3) {
                let possibleParam = $routeParams.landingPageV3 && $routeParams.landingPageV3.match(/(?:\d+-\d+-)(\d+)(?:-\d+)/) || [];
                tmParam = possibleParam && possibleParam[1] !== '1' ? '1' : tmParam;
                route = $routeParams.landingPageV3;
            } else if ($routeParams.landingPageV2) {
                let possibleParam = $routeParams.landingPageV2 && $routeParams.landingPageV2.match(/(?:\d+-\d+-)(\d+)?/) || [];
                tmParam = possibleParam && possibleParam[1] !== '1' ? '1' : tmParam;
                route = $routeParams.landingPageV2;
            }
            return destinationService.fromUrl(`/${route}/${$routeParams.urlText}`, tmParam)
                .then(destinationService.setFidFromDestinationFilter)
                .then(destinationService.enhanceLegacyDestination)
                .then(destinationService.getDetails);
        }
        if (options.useLandingPage && $routeParams.landingPage) {
            return destinationService.fromUrl(`/${$routeParams.landingPage}.html`, $routeParams.tm)
                .then(destinationService.enhanceLegacyDestination)
                .then(destinationService.getDetails);
        }
        if (options.useSearchUnitService) {
            return $q.when(searchUnitService.getDestination());
        }
        return $q.when();
    }

    return service;
}
})();
